import React, { SVGProps } from 'react'

export const FirstActiveCenterSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="36"
    fill="none"
    viewBox="0 0 74 36"
    preserveAspectRatio="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M0 35.928 51.503 36c6.453 0 15.092-.135 22.497-1.072V3.937C68.39 2.5 61.048 1.197 51.503.967 27.703.39 10.982-.866 0 .93v34.998Z"
    />
  </svg>
)
